export enum OtpOperationType {
  FORGOTTEN_PWD = "FORGOTTEN_PWD",
  RESET_PWD = "RESET_PWD",
  CHANGE_PWD = "CHANGE_PWD",
  CHG_MOBILE_NUMBER = "CHG_MOBILE_NUMBER",
  VERIFY_MOBILE_NUMBER = "VERIFY_MOBILE_NUMBER",
}

export enum ContactsType {
  SMS = "SMS",
  EMAIL = "EMAIL",
}

export const STATE_IDENTIFIER = {
  TEMP_TOKEN: "tempToken",
  TEMP_TOKEN_TYPE: "tempTokenType",
  CALL_STATE: "callState",
  PWD_POLICY: "pwdPolicy",
  UIGP_OTP_RECEIVER: "uigpOtpReceiver",
  AUTH_RESPONSE_ERROR: "authResponseError",
}

export interface SecurityQuestionBody {
  accountId: string
  identitySystemId?: string
  newPassword?: string
  answers: SecurityAnswer[]
}

export interface SecurityAnswer {
  id: string
  oldId: string
  question: string
  answer: string
}

export interface UigpOtpBody {
  accountId: string
  identitySystemId: string
  otp: string
  newPassword?: string
}


export interface ChangePasswordModel {
  password: string
  accountId: string
  identitySystemId: string
}

export const CHECK_PASSWORD_ERROR_CODES: Record<string, string> = {
  "PWD_MIN_LENGTH_REQUIRED": 'Minimum Length',
  "PWD_EXCEED_MAX_LENGTH": 'Maximum Length',
  "PWD_MIN_LOWER_CHAR_DISABLED": 'Allow Lowercase',
  "PWD_MIN_LOWER_CHAR_REQUIRED": 'Minimum lowercase Characters',
  "PWD_MIN_UPPER_CHAR_DISABLED": 'Allow Uppercase',
  "PWD_MIN_UPPER_CHAR_REQUIRED": 'Minimum uppercase Characters',
  "PWD_MIN_PUNCTATION_CHAR_DISABLED": 'Allow Special Characters',
  "PWD_MIN_PUNCTATION_CHAR_REQUIRED": 'Minimum Special Characters',
  "PWD_MIN_NUMERICAL_CHAR_DISABLED": 'Allow Numerical Characters',
  "PWD_MIN_NUMERICAL_CHAR_REQUIRED": 'Minimum Numerical Characters',
  "PWD_CONTAIN_PERSONAL_INFO": 'Verify with Personal Data',
  "MAX_REPEATED_CHAR_EXEEDED": 'Maximum Repeated Characters',
  "PWD_MUST_BE_DIFFERENT_LAST_PWDS": 'Not equivalent to last Password',
  "PWD_CHARACTER_NOT_VALID": 'Absence of any of the selected special characters from the list of special characters mentioned in the list of Password Policy',
}